var React = require("react");

var styled = require("styled-components").default;

module.exports = MainHeader;

function MainHeader(props) {
  return React.createElement(StyledMainHeader, {
    className: props.className,
    title: props.title
  }, props.image, props.title && React.createElement(StyledTitle, null, props.title));
}

var StyledMainHeader = styled.div.withConfig({
  displayName: "main-header__StyledMainHeader"
})(["width:100%;height:auto;color:", ";background-color:", ";", ";"], function (props) {
  return props.theme.color;
}, function (props) {
  return props.theme.backgroundSecondary;
}, function (props) {
  return !props.image && "\n\t\tdisplay: flex;\n\t\tpadding: 10px 15px;\n\t\tcolor: ".concat(props.theme.active, ";\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t");
});
var StyledTitle = styled.span.withConfig({
  displayName: "main-header__StyledTitle"
})(["font-family:", ";"], function (props) {
  return props.theme.fonts.default;
});
//# sourceMappingURL=index.js.map